import { useRef } from 'react';

/**
 * A React hook returns the max number that is ever passed in.
 * @param {number} number - The number passed in.
 * @returns {number} - The max number.
 */
export const useMax = (number: number): number => {
  const max = useRef<number>(number);
  max.current = Math.max(max.current, number);
  return max.current;
};
